import { render, staticRenderFns } from "./DialogAddRectificaition.vue?vue&type=template&id=1784e90d&scoped=true&"
import script from "./DialogAddRectificaition.vue?vue&type=script&lang=js&"
export * from "./DialogAddRectificaition.vue?vue&type=script&lang=js&"
import style0 from "./DialogAddRectificaition.vue?vue&type=style&index=0&id=1784e90d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1784e90d",
  null
  
)

export default component.exports